import { useState } from "react";

import styles from "./NumberInputWithDecimals.module.scss";

function NumberInputWithDecimals({
    numberValue,
    onChange,
    dataCy,
    disabled,
    regex,
    unit,
    isInvalid
}: Readonly<{
    numberValue: number | null;
    onChange: (value: string | null, numberValue: number | null) => void;
    dataCy?: string;
    disabled?: boolean;
    regex?: RegExp;
    unit?: string;
    isInvalid?: boolean;
}>): JSX.Element {
    const [localValue, setLocalValue] = useState(
        numberValue?.toString() ?? null
    );
    const decimalRegex = regex ?? /^(?:0(?:\.\d{0,2})?|[1-9]\d{0,2}(?:\.\d{0,2})?)?$/;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const newValue = e.target.value;

        if (newValue.trim() === "") {
            setLocalValue(null);
            onChange(null, null);
        }
        else if (decimalRegex.test(newValue)) {
            setLocalValue(newValue);
            const parsed = Number(newValue);
            onChange(newValue, Number.isNaN(parsed) ? null : parsed);
        }
    };

    return (
        <div className="inline-flex-center">
            <input
                type="text"
                inputMode="decimal"
                value={localValue ?? ""}
                onChange={handleChange}
                data-cy={dataCy}
                disabled={disabled}
                className={`form-control ${styles.input} ${isInvalid ? " invalid" : ""}`}
            />
            {unit && (
                <span className={`padding-sm-left ${styles.unit}`}>
                    {unit}
                </span>
            )}
        </div>
    );
}

export { NumberInputWithDecimals };
